import React from 'react';
import { FaSearch, FaListUl, FaTable, FaSpinner } from 'react-icons/fa';

const Loader = ({ currentStep = 0 }) => {
  const steps = [
    { icon: <FaSearch className="spinning" />, text: 'Searching' },
    { icon: <FaListUl />, text: 'Analyzing' },
    { icon: <FaTable />, text: 'Comparing' },
    { icon: <FaSpinner className="spinning" />, text: 'Generating' }
  ];
  
  const messages = [
    'Searching for product information...',
    'Analyzing product specifications...',
    'Comparing key features and attributes...',
    'Generating your comparison table...'
  ];
  
  // Calculate progress based on currentStep (each step is 25% of progress)
  const progress = Math.min((currentStep + 1) * 25, 100);
  const currentMessage = messages[currentStep];
  
  return (
    <div className="loader-container">
      <div className="loader-animation">
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <div className={`loader-step ${index === currentStep ? 'active' : ''}`}>
              <div className="loader-icon">{step.icon}</div>
              <div>{step.text}</div>
            </div>
            
            {index < steps.length - 1 && (
              <div className="loader-connector"></div>
            )}
          </React.Fragment>
        ))}
      </div>
      
      <div className="loader-text">{currentMessage}</div>
      
      <div className="progress-bar">
        <div 
          className="progress-fill" 
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default Loader; 